// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adm-mask {\n  --z-index: var(--adm-mask-z-index, 1000);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--z-index);\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.adm-mask-aria-button {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n.adm-mask-content {\n  z-index: 1;\n}\n", ""]);
// Exports
module.exports = exports;
